module.exports = __webpack_public_path__ + "static/media/Load-100.5866949a.svg";